import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import * as moment from 'moment-timezone';
import { ToastrService } from 'ngx-toastr';
import { DateFormat } from 'src/app/core/constants/app.constant';
import { ConfirmDialogComponent } from 'src/app/core/dialog/confirm-dialog/confirm-dialog.component';
import { IResponse } from 'src/app/shared/models/app';
import { ConfigureEodComponent } from './configure-eod/configure-eod.component';
import { EodReportService } from './eod-report.service';

@Component({
    selector: 'nphs-user-eod-report',
    templateUrl: './eod-report.component.html',
    styleUrls: ['./eod-report.component.scss'],
    standalone: false
})
export class EodReportComponent implements OnInit {
  /*********************Properties*********************/
  isTimeValid: boolean = true;
  red = '../../../../assets/images/del_red_icon.png';
  green = '../../../../../../assets/images/tick_icon_green.png';
  data = {};
  selectedDate: any;
  date = new UntypedFormControl(moment().format(), [Validators.required]);
  time = new UntypedFormControl(moment().format(DateFormat.HHMM), [
    Validators.required,
  ]);

  //page
  types = ['procedure', 'order', 'inventory', 'waste', 'task', 'personnel'];
  openStatus: any = {};
  status: any;

  dateTimeError = false;
  dateTimeFormatError = false;
  dayboardDate: any;
  currentStatus = {};
  signoffTime: any;
  note: any;
  dateOnly: any;
  timeOnly: any;
  onlyDate: any;
  onlyTime: any;
  buttonName: any = 'test';
  save: any;
  readOnly: any;
  message: any;
  signOffDateTimeInput: any;
  callbacks: any;
  eodDateTime: any;
  eodConfig: any = {};


  rows = [
    { id: 1, desc: 'foo', showDetail: false },
    { id: 2, desc: 'bar', showDetail: false },
  ];

  // daily report data

  dailyReportChecked: boolean = false;
  exportFormat = "PDF";
  dailyreportid: number = 72;
  listOfSelectedShipTo: any;
  dailyReportName:string="Consolidated Eod Daily Report";
  

  // daily report data

  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    private eodReportService: EodReportService,
    private toasterService: ToastrService,
    public dialog: MatDialogRef<EodReportComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogdata,
    public dialogRef: MatDialog
  ) { }
  /*********************Constructor*********************/

  /*********************Lifecyle Methods*********************/
  ngOnInit(): void {
    this.eodDateTime = moment(this.dialogdata.dayBoardDate).format(
      DateFormat.MMDDYYYY
    );
    this.load();
    this.listOfSelectedShipTo = this.dialogdata.listOfSelectedShipTo;
  }
  /*********************Lifecyle Methods*********************/

  /*********************Private Methods*********************/
  private load() {
    this.setDateTime();
    this.getEodReport();

    //Set data in EOD config
    // this.eodReportService.getActiveUserList().subscribe((res: any) => {
    //   this.eodConfig.recipients = res.data.ActiveUserList.activeUsers;
    //   this.eodConfig.defaultUser = res.data.ActiveUserList.defaultUser;
    // });
  }

  private getEodReport() {
    this.dayboardDate = this.selectedDate;
    this.eodReportService.eodStatus(this.dialogdata.dayBoardDate).subscribe((response: any) => {
      //change date later
      this.pageLoad(response.data);
      this.procedureStatus();
      this.orderStatus();
      this.expiredInventoryStatus();
      this.rfdBinStatus();
      this.taskCompletionStatus();
      this.personnelStatus();
    });
  }
  /*********************Private Methods*********************/

  /*********************Component Methods*********************/
  procedureStatus() {
    this.eodReportService
      .procedureStatus(this.dialogdata.dayBoardDate)
      .subscribe((response: any) => {
        this.updateStatus('procedure', response.data);
      });
  }

  orderStatus() {
    this.eodReportService
      .orderStatus(this.dialogdata.dayBoardDate)
      .subscribe((response: any) => {
        this.updateStatus('order', response.data);
      });
  }

  expiredInventoryStatus() {
    this.eodReportService
      .expiredInventoryStatus(this.dialogdata.dayBoardDate)
      .subscribe((response: any) => {
        this.updateStatus('inventory', response.data);
      });
  }

  rfdBinStatus() {
    this.eodReportService
      .rfdBinStatus(this.dialogdata.dayBoardDate)
      .subscribe((response: any) => {
        this.updateStatus('waste', response.data);
      });
  }

  taskCompletionStatus() {
    this.eodReportService
      .taskCompletionStatus(this.dialogdata.dayBoardDate)
      .subscribe((response: any) => {
        this.updateStatus('task', response.data);
      });
  }

  personnelStatus() {
    this.eodReportService
      .personnelTaskCompletionStatus(this.dialogdata.dayBoardDate)
      .subscribe((response: any) => {
        this.updateStatus('personnel', response.data);
      });
  }

  signOff() {
    this.setDateTime();
    this.eodReportService.signOff(this).subscribe((response: any) => {
      if (!response.hasError) {
        this.dialog.close();
        this.toasterService.success('End of day report is completed.');
      } else {
        this.toasterService.error('Something went wrong.');
      }
    });
    if (this.dailyReportChecked == true) {
      this.getDailyReport();
    }
  }



  pageLoad(data) {
    this.currentStatus = {};
    this.accordionReset();
    if (data.signoffTime) {
      this.status = {
        procedure: data.procedure,
        order: data.order,
        inventory: data.inventory,
        waste: data.waste,
        personnel: data.personnel,
        task: data.task,
      };
      this.signoffTime = new Date(data.signoffTime);
      this.note = data.note;
      this.date.setValue(moment(this.signoffTime).format());
      this.time.setValue(moment(this.signoffTime).format(DateFormat.HHMM));
    } else {
      this.reset();
    }
    this.setDateTime();
    //this.changeSignOffTime();
    //this.changeSignOffDate();
  }

  accordionReset() {
    this.types.forEach((type) => {
      this.openStatus[type] = false;
    });
  }

  reset() {
    this.status = {};
    var currDate = new Date();
    var myDate = new Date(this.dayboardDate);
    myDate.setHours(currDate.getHours());
    myDate.setMinutes(currDate.getMinutes());
    this.signoffTime = myDate;
    this.note = '';
    this.buttonName = 'SIGN OFF';
    this.save = this.signOff;
    this.readOnly = false;
    this.message = '';
  }

  updateStatus(param, value) {
    if (this.status[param]) {
      this.currentStatus[param] = value;
      this.readOnly = true;
      this.buttonName = 'SIGN OFF AGAIN';
      this.save = this.signOffAgain;
      if (this.isDifferent(param)) {
        this.message =
          'The status for at least one item has changed since after last sign off. Click on' +
          ' ' +
          this.buttonName +
          ' ' +
          'to view latest status and sign off';
      }
    } else {
      this.status[param] = value;
      this.buttonName = 'SIGN OFF';
      this.save = this.signOff;
    }
  }

  isDifferent(param) {
    var retVal = false;
    if (param == 'order') {
      retVal =
        this.status[param].online.remaining !=
        this.currentStatus[param].online.remaining ||
        this.status[param].offline.remaining !=
        this.currentStatus[param].offline.remaining;
    } else {
      retVal =
        this.status[param]?.remaining != this.currentStatus[param]?.remaining;
    }
    return retVal;
  }

  signOffAgain() {
    this.reset();
    this.status = { ...this.currentStatus };
    this.setDateTime(); //  this.changeSignOffTime();
  }

  setDateTime() {
    let date =
      moment(this.date.value).format(DateFormat.MMDDYYYY) +
      ' ' +
      this.time.value;
    this.signoffTime = moment(date).format();
  }

  hasAnyError() {
    return this.dateTimeError || this.dateTimeFormatError;
  }

  isOpen(type) {
    return this.openStatus[type];
  }

  handleOpen(type) {
    if (this.allowStatusChange(type)) {
      this.openStatus[type] = !this.openStatus[type];
    }
  }

  allowStatusChange(type) {
    var retVal = false;
    if (this.status) {
      var typeValue = this.status[type];
      switch (type) {
        case 'procedure':
          retVal = typeValue.remaining > 0;
          break;
        case 'order':
          retVal =
            typeValue.offline.remaining > 0 || typeValue.online.remaining > 0;
          break;
        case 'inventory':
          retVal = typeValue.remaining > 0;
          break;
        case 'waste':
          retVal = typeValue.remaining > 0;
          break;
        case 'task':
          retVal = typeValue.remaining > 0;
          break;
        case 'personnel':
          retVal = typeValue.remaining > 0;
          break;
      }
    }
    return retVal;
  }

  // close() {
  //   this.dialog.close();
  //  }

  showEodReportConfig() {
    // eodReportService.eodConfiguration().then(function(response){
    // 	vm.eodConfig.load(response);
    // 	$('#viewConfigureEodReportModal').show();
    // 	$('#viewEodreportModal').hide();
    // });

    this.eodReportService.eodConfiguration().subscribe((res: IResponse) => {
      this.eodConfig.data = res.data ? res.data : null;
      this.dialogRef.open(ConfigureEodComponent, {
        data: this.eodConfig,
        panelClass: 'configure-eod-dialog',
      });
    });
  }
  /*********************Component Methods*********************/

  /*********************Getter/Setter*********************/
  get isDateTimeInvalid(): boolean {
    if (!this.isDateTimeRequired) {
      if (this.date.errors?.matDatepickerParse) {
        return true;
      } else if (!this.isTimeValid) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get isDateTimeRequired(): boolean {
    if (
      (this.date.errors?.required && !this.date.errors?.matDatepickerParse) ||
      this.time.errors?.required
    ) {
      return true;
    } else {
      return false;
    }
  }
  /*********************Getter/Setter*********************/

  // daily report changes

  dailyReport() {
    this.dailyReportChecked = !this.dailyReportChecked;
  }

  getDailyReport() {
    const dailyReportData = {
      endDate: this.eodDateTime,
      exportFormat: this.exportFormat,
      id: this.dailyreportid,
      listOfSelectedShipTo: this.listOfSelectedShipTo,
      name: this.dailyReportName,
      startDate: this.eodDateTime,
    }
    this.eodReportService.getDailyReport(dailyReportData, this.dailyreportid).subscribe((Response: IResponse) => {
      if (!Response.hasError) {
        this.dialogRef
          .open(ConfirmDialogComponent, {
            panelClass: 'confirm-dialog',
            data: {
              title: 'Daily Report',
              message: 'Go to Download Reports to view consolidated daily report.',
              isOk: true
            }
          })
      }

    })
  }
}
